import ProductDescription from './ProductDescription'

const InfantCerealProduct = {
  ...ProductDescription,
  category: '09',
  subCategory: '001BS',
  IsBroadband: true,
  GrainType: '',
  OtherGrainType: null,
  Iron: '',
  IronCertification: false,
  NoAdditionalIngredients: false,
  Size: '',
  Organic: false,
}

export default InfantCerealProduct
